import React, { Component } from 'react';

import { Grid, Typography, TextField, Button, Link, Paper } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';

import { MyPATTextField, MyPATLink } from '../../common';

import { ForgotPasswordRequest, ForgotPasswordError } from '../types/ForgotPassword';
import { userService } from '../services/userService';

const styles = (theme: Theme) => createStyles({
  paper: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    "& img": {
      margin: "0 auto",
    }
  },
  logo: {
    // paddingTop: theme.spacing.unit * 6,
  },
  loginBox: {
    textAlign: 'left',
    maxWidth: '420px',
    margin: '0 auto !important',
    paddingBottom: theme.spacing.unit * 4,
    '& > *': {
      width: '100%',
    },
    '& input': {
      height: 35,
    },
    '& label':{
      top: 'initial',
    }
  },

  loginButton: {
    background: '#1d7dea',
    color: theme.palette.common.white,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    borderRadius: `${theme.spacing.unit * 7}px`,
    marginTop: `${theme.spacing.unit}px`,
    maxWidth: 120,
    width: '100%',
    float: 'left',
    '&:hover':{
      backgroundColor:'#1d7dea!important',
    },
  },
  forgotLink: {
    float: 'right',
    color: '#1d7dea',
    marginTop: `${theme.spacing.unit + 4}px`
  },
  clearfix: {
    display: 'table',
    clear: 'both'
  },
  title1:{
    fontSize: 22,
  },
  subtitle1:{
    fontSize: 14,
    color: '#999',
  },
  logoCont:{
    margin: '0 auto !important',
    maxWidth: 420,
    textAlign: 'left',
    paddingBottom: 32,
    width: '100%',
  },
  formContainer: {
    maxWidth: '400px',
    width: '100%',
    margin: '0 150px 0',
  }
});


export interface ForgotPasswordState {
  form: ForgotPasswordRequest,
  formError: ForgotPasswordError,
  isFormSubmitted: boolean,
}

//@ts-ignore
export interface ForgotPasswordProps extends WithStyles<typeof styles> {
  classes: any,
  forgotPassword: Function,
}

class ForgotPassword extends Component<ForgotPasswordProps, ForgotPasswordState> {

  constructor(props: ForgotPasswordProps, state: ForgotPasswordState) {
    super(props)

    this.state = {
      form: {
        email: '',
        
      },
      formError: {
        email: '',
        
      },
      isFormSubmitted: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e: any) {
    const { name, value } = e.target;
    let form: any = this.state.form;
    form[name] = value;
    this.setState({ form: form });
  }
  handleSubmit(e: any) {
    e.preventDefault();
    this.setState({ isFormSubmitted: true });

    const { form } = this.state;
    let formError: ForgotPasswordError = {
      email: '',
      
    }

    if (!form.email) {
      formError.email = "Email is required";
    }

    if (!form.email) {
      this.setState({ formError });
      return;
    }
    

    this.props.forgotPassword(form)
  }

  render() {
    const { classes } = this.props;
    const { form, formError } = this.state;

    return (
      <Paper className={classes.paper} >
        <form className={classes.formContainer} onSubmit={this.handleSubmit}>
          <Grid container direction="column">
            <Grid item className={classes.logoCont}>
            <img src="/assets/svg/authors-new-logo.svg" className={classes.logo}></img>
            </Grid>
            <Grid item>
              <div className={classes.loginBox}>
                <Typography className={classes.title1} variant="h5"><strong>Forgot Password.</strong></Typography>
                <Typography className={classes.subtitle1} variant="subtitle1">Enter your Email ID to receive the password link</Typography><br />
                <MyPATTextField
                  id="outlined-username-input"
                  label="Email"
                  name="email"
                  autoComplete="userName"
                  variant="outlined"
                  error={formError.email != ""}
                  errorText={formError.email}
                  onChange={this.handleChange}
                />
                
                <div>
                  <Button type="submit"
                    className={classes.loginButton}
                    variant="text">
                    Verify
                    </Button>
                    <MyPATLink align="right" variant="body2" className={classes.forgotLink} to="/login">Back to Login</MyPATLink>
                  <div className={classes.clearfix}></div>
                </div>
              </div>
            </Grid>
          </Grid>
        </form>
      </Paper>
    );
  }
}

//@ts-ignore
export default withStyles(styles)(ForgotPassword);